/** Canonical typed refusal of a desktop ticket while the session is not ready yet. The daemon answers with it,
 * the web client retries on it. The web build-root mirror is byte-pinned by webMirrorContracts. */
import { z } from 'zod';

export const desktopTicketUnavailableSchema = z.object({
  error: z.literal('desktop_session_unavailable'),
  reason: z.enum(['session_missing', 'session_not_ready']),
  retryable: z.literal(true),
}).passthrough();
